// extracted by mini-css-extract-plugin
module.exports = {"root":"XTHg8ZHD","icon":"sejjR2QQ","capitalizedText":"N6kosmLK","gray":"ElfNwuk5","blue":"MzPuB1CC","violet":"S89Gl7Ry","green":"_5p0ktSHO"};